import React from 'react';
import { FiFacebook, FiTwitter, FiInstagram } from 'react-icons/fi';

import { images } from '../../constants';
import './Footer.css';

const Footer = () => (
    <div className="app__footer section__padding" id="login">

      <div className="app__footer-links">
        <div className="app__footer-links_contact">
          <h1 className="app__footer-headtext">Contact</h1>
          <p className="p__opensans3">Adresse : 34 Rue de Miromesnil, Paris 75008</p>
        </div>

        <div className="app__footer-links_logo">
          <img src={images.mirodeliceLogo} alt="footer_logo" />
          <p className="app__footer-headtext">&quot;Au Mirodélice&quot;</p>

          <div className="app__footer-links_icons">
            {/*<FiFacebook />
            <FiTwitter />
            <FiInstagram />*/}
          </div>
        </div>

        <div className="app__footer-links_work">
          <h1 className="app__footer-headtext">Heures d’ouverture</h1>
          <p className="p__opensans3">Lundi - Vendredi : 10:30  - 19:30 </p>
        </div>
      </div>

      <div className="footer__copyright">
        <p className="p__opensans3">2026 Au Mirodélice. Tous droits réservés. Auteur: Vato.</p>
      </div>
    </div>
);

export default Footer;